<script>
import { useUserStore } from '@/store/userStore';
// import axios from 'axios';
import api from '@/services/api';
export default {
    data() {
        return {
            signedurlid: 0
        }
    },
    computed: {
       
    },
    methods: {
        processFileWithoutLogin(event) {
            let file = event.target.files[0];
            console.log("File", file)
           
            let obj = useUserStore().filecomponents;
            console.log("Obj", obj)
            let extention = file.name.split('.').pop();
            let self = this;
            if (extention == 'jpg' || extention == 'jpeg' || extention == 'png') {
                var _URL = window.URL || window.webkitURL;
                let img = new Image();
                var objectUrl = _URL.createObjectURL(file);
                img.onload = function () { 
                    let width = this.width;
                    let height = this.height;
                    let uploadimgsize = this.width + "*" + this.height
                    console.log('check',width,height)
                    if(obj.width=='1000' && obj.height=='1000'){
                        let size = file.size;
                        let filesize = Math.round((size / 1024));
                        if (filesize <= 1024) {
                            obj.width = 1000;
                            obj.height = 1000;
                            self.processFiletoupladWithoutLogin(file, obj);
                        } else {
                            self.errortext = "please select a file less than 1mb";
                            alert(self.errortext);
                        }
                    }else{
                        if (width == obj.width && height == obj.height) {
                            self.processFiletoupladWithoutLogin(file, obj);
                        } else {
                            self.errortext = 'Size not Valid your image size ' + uploadimgsize;
                            alert(self.errortext);
                        }
                    }
                    
                    _URL.revokeObjectURL(objectUrl);
                };
                img.src = objectUrl;
            } else {
                self.processFiletoupladWithoutLogin(file, obj);
            }
            // this.$store.commit('assignloadingstatus', 0)
        },
        processFiletoupladWithoutLogin(file, obj) {
            let extention = file.name.split('.').pop();
            let param = {
                width: obj.width, height: obj.height, filetype: extention, size: file.size, counter: obj.counter,filename:file.name,
                type: obj.type, imagetype: obj.type, typeid: obj.typeid, directorypath: obj.directorypath, typeint: obj.typeint
                ,companyid: obj.companyid,fieldjson:JSON.stringify(useUserStore().fieldjson)
            }
            console.log(param);
            api.post('api/without/login/getpresignedurl', param)
                .then(response => this.processFileResponseWithoutLogin(file, response.data))
                .catch(error => console.log(error));
        },
        processFileResponseWithoutLogin(file, data) {
            //if everything is fine then upload to the server
            if (!data.success) {
                alert(data.message)
            } else {
                this.signedurlid = data.presignedid
                console.log("seignedurlid", this.signedurlid)
                this.uploadImageToS3WithoutLogin(file, data)
            }
        },
        uploadImageToS3WithoutLogin(file, signedurlobject) {
            let newfile = new File([file], signedurlobject.filename, { type: file.type });
            let instance = api.create();
            delete instance.defaults.headers.common['Authorization'];
            instance.put(signedurlobject.uploadUrl, newfile, {
                headers: {
                    'Content-Type': file.type,
                }
            }).then(response => this.processUploadResponseWithoutLogin(response))
                .catch(error => console.log(error));

        },
        processUploadResponseWithoutLogin() {
            //create a row in the image folder and save the reference in the signed url also
            let param = { signedid: this.signedurlid }
            api.post('api/without/login/savedtoamazon', param)
                .then((response) => {
                    // this.$store.commit('assignuploadedimage', response.data)
                    useUserStore().setuploadedimage(response.data);
                    this.uploaded();
                }).catch((err) => {
                    console.log('Error in loading image to the server', err)
                });
        },
        
        processFile2(event) {
            let file = event.target.files[0];
            console.log("File", file)
           
            let obj = useUserStore().filecomponents;
            console.log("Obj", obj)
            let extention = file.name.split('.').pop();
            let self = this;
            if (extention == 'jpg' || extention == 'jpeg' || extention == 'png') {
                var _URL = window.URL || window.webkitURL;
                let img = new Image();
                var objectUrl = _URL.createObjectURL(file);
                img.onload = function () { 
                    let width = this.width;
                    let height = this.height;
                    let uploadimgsize = this.width + "*" + this.height
                    console.log('check',width,height)
                    if(obj.width=='1000' && obj.height=='1000'){
                        let size = file.size;
                        let filesize = Math.round((size / 1024));
                        if (filesize <= 1024) {
                            obj.width = 1000;
                            obj.height = 1000;
                            self.processFiletouplad(file, obj);
                        } else {
                            self.errortext = "please select a file less than 1mb";
                            alert(self.errortext);
                        }
                    }else{
                        if (width == obj.width && height == obj.height) {
                            self.processFiletouplad(file, obj);
                        } else {
                            self.errortext = 'Size not Valid your image size ' + uploadimgsize;
                            alert(self.errortext);
                        }
                    }
                    
                    _URL.revokeObjectURL(objectUrl);
                };
                img.src = objectUrl;
            } else {
                self.processFiletouplad(file, obj);
            }
            // this.$store.commit('assignloadingstatus', 0)
        },
        processFiletouplad(file, obj) {
            let extention = file.name.split('.').pop();
            let param = {
                width: obj.width, height: obj.height, filetype: extention, size: file.size, counter: obj.counter,filename:file.name,
                type: obj.type, imagetype: obj.type, typeid: obj.typeid, directorypath: obj.directorypath, typeint: obj.typeint
                ,companyid: obj.companyid,fieldjson:JSON.stringify(useUserStore().fieldjson)
            }
            console.log(param);
            api.post('api/image/getpresignedurl', param)
                .then(response => this.processFileResponse(file, response.data))
                .catch(error => console.log(error));
        },
        processFileResponse(file, data) {
            //if everything is fine then upload to the server
            if (!data.success) {
                alert(data.message)
            } else {
                this.signedurlid = data.presignedid
                // console.log("file",file)
                // this.$store.commit('assignuplaodeddocument',data)
                console.log("seignedurlid", this.signedurlid)
                this.uploadImageToS3(file, data)
            }
        },
        uploadImageToS3(file, signedurlobject) {
            let newfile = new File([file], signedurlobject.filename, { type: file.type });
            let instance = api.create();
            delete instance.defaults.headers.common['Authorization'];
            instance.put(signedurlobject.uploadUrl, newfile, {
                headers: {
                    'Content-Type': file.type,
                }
            }).then(response => this.processUploadResponse(response))
                .catch(error => console.log(error));

        },
        processUploadResponse() {
            //create a row in the image folder and save the reference in the signed url also
            let param = { signedid: this.signedurlid }
            api.post('api/upload/savedtoamazon', param)
                .then((response) => {
                    // this.$store.commit('assignuploadedimage', response.data)
                    useUserStore().setuploadedimage(response.data);
                    this.uploaded();
                }).catch((err) => {
                    console.log('Error in loading image to the server', err)
                });
        },
    }
}
</script>